(function($) {
    $(() => {
        console.log('Hello 2.2!');
    });
})(jQuery);
